import Button from "../Button/Button";
import EmptyView from "../EmptyView";
import { getErrorMessage } from "../form/utilities";

export type ErrorScreenProps = {
    error: unknown;
    onRetry: () => void;
};

export default function ErrorScreen(props: ErrorScreenProps) {
    const { error, onRetry } = props;
    return (
        <EmptyView
            message={getErrorMessage(error)}
            callToAction={<Button label="Réessayer" action={onRetry} />}
        />
    );
}
